import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { palette } from "../../../../../styles/design-tokens";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            pl: 2.3,
            pt: 1,
            pr: 2,
            overflow: "hidden",
            backgroundColor: palette["White"],
          }}
        >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
